<template>
  <v-card class="pa-4 mx-auto" max-width="1200">

    <v-toolbar-title>Настройки</v-toolbar-title>

    <v-row align="center" class="mt-3">
      <v-col class="d-flex.align-center" cols="12" sm="6" lg="4">
        <v-select
          :items="clubItems"
          clearable
          label="Клуб"
          @change="onChangeClub"
          v-model="clubID"
        >
        </v-select>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>

import ClubListGQL from '@/graphql/private/Club/List.gql'

/**
 * @displayName Post settings
 */
export default {
  props: {
    clubID: {
      type: String
    },
  },
  apollo: {
    clubList: {
      query: ClubListGQL,
      variables() {
        return {
          filter: {
            locale: 'ru',
          },
        }
      },
    },
  },
  computed: {
    clubItems() {
      if (!this.clubList) {
        return []
      }
      return this.clubList.map(item => {
        return {
          text: item.name,
          value: item.id,
        }
      })
    },
  },
  methods: {
    onChangeClub(val) {
      /**
       * Triggers when language changes
       *
       * @property {string|object} val
       */
      this.$emit('clubChanged', val)
    },
  },
}
</script>
